const countryList = {
  "36": "Австралия",
  "40": "Австрия",
  "31": "Азербайджан",
  "248": "Аландские о-ва",
  "8": "Албания",
  "12": "Алжир",
  "16": "Американское Самоа",
  "660": "Ангилья",
  "24": "Ангола",
  "20": "Андорра",
  "10": "Антарктида",
  "28": "Антигуа и Барбуда",
  "32": "Аргентина",
  "51": "Армения",
  "533": "Аруба",
  "4": "Афганистан",
  "44": "Багамы",
  "50": "Бангладеш",
  "52": "Барбадос",
  "48": "Бахрейн",
  "112": "Республика Беларусь",
  "84": "Белиз",
  "56": "Бельгия",
  "204": "Бенин",
  "60": "Бермудские о-ва",
  "100": "Болгария",
  "68": "Боливия",
  "535": "Бонэйр, Синт-Эстатиус и Саба",
  "70": "Босния и Герцеговина",
  "72": "Ботсвана",
  "76": "Бразилия",
  "86": "Британская территория в Индийском океане",
  "96": "Бруней-Даруссалам",
  "854": "Буркина-Фасо",
  "108": "Бурунди",
  "64": "Бутан",
  "548": "Вануату",
  "336": "Ватикан",
  "826": "Великобритания",
  "348": "Венгрия",
  "862": "Венесуэла",
  "92": "Виргинские о-ва (Великобритания)",
  "850": "Виргинские о-ва (США)",
  "581": "Внешние малые о-ва (США)",
  "626": "Восточный Тимор",
  "704": "Вьетнам",
  "266": "Габон",
  "332": "Гаити",
  "328": "Гайана",
  "270": "Гамбия",
  "288": "Гана",
  "312": "Гваделупа",
  "320": "Гватемала",
  "324": "Гвинея",
  "624": "Гвинея-Бисау",
  "276": "Германия",
  "831": "Гернси",
  "292": "Гибралтар",
  "340": "Гондурас",
  "344": "Гонконг (САР)",
  "308": "Гренада",
  "304": "Гренландия",
  "300": "Греция",
  "268": "Грузия",
  "316": "Гуам",
  "208": "Дания",
  "832": "Джерси",
  "262": "Джибути",
  "212": "Доминика",
  "214": "Доминиканская Республика",
  "818": "Египет",
  "894": "Замбия",
  "732": "Западная Сахара",
  "716": "Зимбабве",
  "376": "Израиль",
  "356": "Индия",
  "360": "Индонезия",
  "400": "Иордания",
  "368": "Ирак",
  "364": "Иран",
  "372": "Ирландия",
  "352": "Исландия",
  "724": "Испания",
  "380": "Италия",
  "887": "Йемен",
  "132": "Кабо-Верде",
  "3": "Казахстан",
  "116": "Камбоджа",
  "120": "Камерун",
  "124": "Канада",
  "634": "Катар",
  "404": "Кения",
  "196": "Кипр",
  "417": "Киргизия",
  "296": "Кирибати",
  "156": "Китай",
  "408": "КНДР",
  "166": "Кокосовые о-ва",
  "170": "Колумбия",
  "174": "Коморы",
  "178": "Конго - Браззавиль",
  "180": "Конго - Киншаса",
  "188": "Коста-Рика",
  "384": "Кот-д’Ивуар",
  "192": "Куба",
  "414": "Кувейт",
  "531": "Кюрасао",
  "418": "Лаос",
  "428": "Латвия",
  "426": "Лесото",
  "430": "Либерия",
  "422": "Ливан",
  "434": "Ливия",
  "440": "Литва",
  "438": "Лихтенштейн",
  "442": "Люксембург",
  "480": "Маврикий",
  "478": "Мавритания",
  "450": "Мадагаскар",
  "175": "Майотта",
  "446": "Макао (САР)",
  "454": "Малави",
  "458": "Малайзия",
  "466": "Мали",
  "462": "Мальдивы",
  "470": "Мальта",
  "504": "Марокко",
  "474": "Мартиника",
  "584": "Маршалловы Острова",
  "484": "Мексика",
  "508": "Мозамбик",
  "498": "Молдова",
  "492": "Монако",
  "496": "Монголия",
  "500": "Монтсеррат",
  "104": "Мьянма (Бирма)",
  "516": "Намибия",
  "520": "Науру",
  "524": "Непал",
  "562": "Нигер",
  "566": "Нигерия",
  "528": "Нидерланды",
  "558": "Никарагуа",
  "570": "Ниуэ",
  "554": "Новая Зеландия",
  "540": "Новая Каледония",
  "578": "Норвегия",
  "74": "о-в Буве",
  "833": "о-в Мэн",
  "574": "о-в Норфолк",
  "162": "о-в Рождества",
  "654": "о-в Св. Елены",
  "612": "о-ва Питкэрн",
  "796": "о-ва Тёркс и Кайкос",
  "334": "о-ва Херд и Макдональд",
  "784": "ОАЭ",
  "512": "Оман",
  "136": "Острова Кайман",
  "184": "Острова Кука",
  "586": "Пакистан",
  "585": "Палау",
  "275": "Палестинские территории",
  "591": "Панама",
  "598": "Папуа — Новая Гвинея",
  "600": "Парагвай",
  "604": "Перу",
  "616": "Польша",
  "620": "Португалия",
  "630": "Пуэрто-Рико",
  "410": "Республика Корея",
  "638": "Реюньон",
  "643": "Россия",
  "646": "Руанда",
  "642": "Румыния",
  "222": "Сальвадор",
  "882": "Самоа",
  "674": "Сан-Марино",
  "678": "Сан-Томе и Принсипи",
  "682": "Саудовская Аравия",
  "807": "Северная Македония",
  "580": "Северные Марианские о-ва",
  "690": "Сейшельские Острова",
  "652": "Сен-Бартелеми",
  "663": "Сен-Мартен",
  "666": "Сен-Пьер и Микелон",
  "686": "Сенегал",
  "670": "Сент-Винсент и Гренадины",
  "659": "Сент-Китс и Невис",
  "662": "Сент-Люсия",
  "688": "Сербия",
  "702": "Сингапур",
  "534": "Синт-Мартен",
  "760": "Сирия",
  "703": "Словакия",
  "705": "Словения",
  "840": "Соединенные Штаты",
  "90": "Соломоновы Острова",
  "706": "Сомали",
  "729": "Судан",
  "740": "Суринам",
  "694": "Сьерра-Леоне",
  "762": "Таджикистан",
  "764": "Таиланд",
  "158": "Тайвань",
  "834": "Танзания",
  "768": "Того",
  "772": "Токелау",
  "776": "Тонга",
  "780": "Тринидад и Тобаго",
  "798": "Тувалу",
  "788": "Тунис",
  "795": "Туркменистан",
  "792": "Турция",
  "800": "Уганда",
  "860": "Узбекистан",
  "804": "Украина",
  "876": "Уоллис и Футуна",
  "858": "Уругвай",
  "234": "Фарерские о-ва",
  "583": "Федеративные Штаты Микронезии",
  "242": "Фиджи",
  "608": "Филиппины",
  "246": "Финляндия",
  "238": "Фолклендские о-ва",
  "250": "Франция",
  "254": "Французская Гвиана",
  "258": "Французская Полинезия",
  "260": "Французские Южные территории",
  "191": "Хорватия",
  "140": "Центрально-Африканская Республика",
  "148": "Чад",
  "499": "Черногория",
  "203": "Чехия",
  "152": "Чили",
  "756": "Швейцария",
  "752": "Швеция",
  "744": "Шпицберген и Ян-Майен",
  "144": "Шри-Ланка",
  "218": "Эквадор",
  "226": "Экваториальная Гвинея",
  "232": "Эритрея",
  "748": "Эсватини",
  "233": "Эстония",
  "231": "Эфиопия",
  "239": "Южная Георгия и Южные Сандвичевы о-ва",
  "710": "Южно-Африканская Республика",
  "728": "Южный Судан",
  "388": "Ямайка",
  "392": "Япония"
};

export default countryList;
